import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['field', 'tooltip'];

  updateField(event) {
    const selectedPrUuid = event.target.value;
    const amendmentPrs = JSON.parse(event.target.dataset.amendmentPrs || '{}');
    const parentPoNumber = amendmentPrs[selectedPrUuid];

    if (parentPoNumber) {
      // Amendment PR - keeps parent PO number
      this.fieldTarget.value = parentPoNumber;
      this.fieldTarget.readOnly = true;
      this.fieldTarget.classList.add('bg-light');
      if (this.hasTooltipTarget) {
        this.tooltipTarget.classList.remove('d-none');
      }
    } else {
      this.fieldTarget.value = '';
      this.fieldTarget.readOnly = false;
      this.fieldTarget.classList.remove('bg-light');
      if (this.hasTooltipTarget) {
        this.tooltipTarget.classList.add('d-none');
      }
    }
  }
}
